<template>
  <div class="quote-compact">
    <v-card class="quote-compact__card">
      <v-container fluid class="p-16 quote-compact__body">
        <v-divider class="my-1 mb-4" />
        <div class="heading orange--text quote-compact__title">
          Pricing details
        </div>

        <div v-if="pricing" class="quote-tiles">
          <div class="quote-tiles__header">
            <v-icon small>payments</v-icon>
            <span>Pricing</span>
          </div>

          <div class="quote-tile quote-tile--customer">
            <div class="quote-tile__text">
              <span class="quote-tile__label">Customer price</span>
              <div class="quote-tile__value">
                <small v-if="currency">{{ currency }}</small>
                {{ formatAmount(pricing.customerCost) }}
              </div>
            </div>
            <button
              v-if="canEditCustomerPrice"
              type="button"
              class="quote-tile__edit-btn"
              title="Edit Customer Price"
              aria-label="Edit Customer Price"
              :disabled="
                viewOnly == 'view' ||
                subJobDetail.isCustomerReceiptInitiated ||
                detail.isJobActivatedByScript
              "
              @click.stop="openCustomerPriceEditor"
            >
              <v-icon small>edit</v-icon>
            </button>
            <customerAccepted
              v-if="canEditCustomerPrice"
              ref="customerPriceEditor"
              class="quote-tile__editor"
              :jobId="detail.jobId"
              :detail="detail"
              :working="workingcountry"
              :viewOnly="viewOnly"
              :subJobDetail="subJobDetail"
              :hide-trigger="true"
            />
          </div>

          <div class="quote-tile">
            <div class="quote-tile__text">
              <span class="quote-tile__label">Driver price</span>
              <div class="quote-tile__value">
                <small v-if="driverCurrency">{{ driverCurrency }}</small>
                {{ formatAmount(pricing.driverCost) }}
              </div>
            </div>
            <button
              type="button"
              class="quote-tile__edit-btn"
              title="Edit Driver Price"
              aria-label="Edit Driver Price"
              :disabled="viewOnly == 'view' || detail.isJobActivatedByScript"
              @click.stop="openDriverPriceEditor"
            >
              <v-icon small>edit</v-icon>
            </button>
            <editDriverPrice
              ref="driverPriceEditor"
              class="quote-tile__editor"
              :jobId="detail.jobId"
              :detail="detail"
              :working="workingcountry"
              :viewOnly="viewOnly"
              :subJobDetail="subJobDetail"
              :hide-trigger="true"
            />
          </div>

          <div v-if="pricing.dutyCharges" class="quote-tile">
            <div class="quote-tile__text">
              <span class="quote-tile__label">Total duty amount</span>
              <div class="quote-tile__value">
                <small v-if="currency">{{ currency }}</small>
                {{ formatAmount(pricing.dutyCharges) }}
              </div>
            </div>
          </div>
        </div>
      </v-container>
      <success-dialog
        :content="x.message"
        :show="x.success"
        :onclose="closeMessage"
      />
    </v-card>
  </div>
</template>
<script>
import { StorageKeys } from "../../../constants/constants";
import ErrorBox from "@/components/Common/ErrorBox";
import SuccessDialog from "@/components/Common/SuccessDialog";
import customerAccepted from "@/components/Pop-ups/customerAccepted";
import editDriverPrice from "@/components/Pop-ups/editDriverPrice";
import { sendQuote } from "../../../constants/api-urls";
import { EventBus } from "../../../event-bus.js";
export default {
  created() {
    this.driverCost = null;
    this.$eventBus.$on("additional-charges-added", (value) => {
      this.additionalCharges = this.additionalCharges + parseInt(value);
      this.trukkinEarning = this.trukkinEarning - this.additionalCharges;
      this.$eventBus.$emit("refresh-job");
    });

    this.quoteToCustomer = this.detail.jobPrice;
    this.trukkinEarning = this.quoteToCustomer - this.driverCost;

    if (this.detail.additionalCharges) {
      this.additionalCharges = this.detail.additionalCharges;
      this.trukkinEarning = this.trukkinEarning - this.additionalCharges;
    }
  },
  props: {
    userId: Number,
    jobId: Number,
    currency: String,
    detail: Object,
    subJobDetail: Object,
    assignment: Array,
    pricing: Object,
    deliveryProof: Array,
    costJobtype: Number,
    viewOnly: String,
    workingcountry: String,
  },
  // props: [
  //   "userId",
  //   "jobId",
  //   "currency",
  //   "detail",
  //   "subJobDetail",
  //   "assignment",
  //   "pricing",
  //   "deliveryProof",
  //   "perAssignmentPrice",
  //   "subJobPrice",
  //   "tabOrder",
  //   "jobType",
  //   "workingcountry",
  //   "viewOnly",
  // ],
  components: {
    ErrorBox,
    SuccessDialog,
    customerAccepted,
    editDriverPrice,
  },
  data() {
    return {
      getJobType(type) {
        switch (type) {
          case "1":
            return "Land";
          case "2":
            return "Air";
          case "3":
            return "Sea";
          default:
            return "Land";
        }
      },
      quoteToCustomer: "",
      driverCost: "",
      trukkinEarning: "",
      processing: false,
      readOnly: true,
      isEmail: true,
      x: {
        error: null,
        message: "",
        loading: false,
        success: false,
      },
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  watch: {},
  computed: {
    canEditCustomerPrice() {
      return (
        this.detail.jobStatus != 2 &&
        this.detail.jobStatus != 9 &&
        this.detail.jobStatus != -1 &&
        !this.detail.isJobActivatedByScript
      );
    },
    // Currency of the assignments summed into the driver price (shown only
    // when they all share one).
    driverCurrency() {
      const currencies = (this.assignment || [])
        .filter((a) => a.paymentAmount && a.assignmentStatus != -1)
        .map((a) => a.paymentCurrency)
        .filter(Boolean);
      const unique = [...new Set(currencies)];
      return unique.length === 1 ? unique[0] : "";
    },
  },
  methods: {
    formatAmount(value) {
      if (value === null || value === undefined || value === "") return "-";
      return this.$formatPrice(value);
    },
    closeMessage() {
      this.processing = false;
      this.x.success = false;
      this.isEmail = true;
      this.$emit("updateJobs");
    },
    sendQuote() {
      if (
        !this.userId ||
        !this.jobId ||
        !this.driverCost.trim() ||
        !this.quoteToCustomer.trim()
      ) {
        this.x.error = "Please fill all fields";
      } else {
        if (this.processing) {
          return;
        } else {
          if (!this.currency) {
            this.processing = false;
            this.x.error = "Please Select the currency.";
            setTimeout(() => (this.x.error = null), 6001);
          } else {
            this.processing = true;
            let url = sendQuote;
            delete this.axios.defaults.headers.common["token"];
            let token = localStorage.getItem(StorageKeys.SessionKey);
            let config = {
              headers: {
                authorization: `bearer ${token}`,
              },
            };
            let body = {
              userId: this.userId.toString(),
              jobId: this.jobId.toString(),
              appCost: "0",
              DriverCost: this.driverCost,
              QuoteToCust: this.quoteToCustomer,
            };
            this.axios.post(this.constants.apiUrl + url, body, config).then(
              (response) => {
                this.x.message = response.data.message;
                this.quoteToCustomer = " ";
                this.driverCost = " ";
                this.trukkinEarning = " ";
                this.trukkinEarning = " ";
                this.$forceUpdate();
                this.processing = false;
                this.x.success = true;
                this.readOnly = true;
                this.isEmail = true;
              },
              (error) => {
                this.processing = false;
                this.dialog = true;
                this.x.error = "Unable to Send Quote.";
              }
            );
          }
        }
      }
    },
    openDriverPriceEditor() {
      const editor = this.$refs.driverPriceEditor;
      if (editor && typeof editor.check === "function") {
        editor.check();
      }
    },
    openCustomerPriceEditor() {
      const editor = this.$refs.customerPriceEditor;
      if (editor && typeof editor.check === "function") {
        editor.check();
      }
    },
  },
};
</script>
<style>
.p-16 {
  padding: 16px !important;
}

.quote-compact .p-16 {
  padding: 12px !important;
}

.quote-compact__card {
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.quote-compact__body .v-divider {
  display: none;
}

.quote-compact__title {
  color: #172033 !important;
  font-size: 13px !important;
  font-weight: 900;
  margin-bottom: 8px;
}

.quote-compact__grid {
  align-items: flex-start;
  display: grid !important;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0 !important;
}

.quote-compact__field {
  flex-basis: auto !important;
  max-width: none !important;
  width: auto !important;
}

.quote-compact__input-row {
  align-items: start;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) 38px;
}

.quote-compact__input-row > .v-input {
  margin-top: 0;
  padding-top: 0;
}

.quote-compact__edit {
  align-self: start;
  display: flex;
  padding-top: 0 !important;
}

.quote-compact__edit .log {
  display: inline-flex;
}

.quote-compact__edit .view-ass-btn {
  align-items: center;
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 8px !important;
  color: #a85510 !important;
  display: inline-flex;
  font-size: 0 !important;
  height: 34px;
  justify-content: center;
  min-width: 34px;
  padding: 0 !important;
  width: 34px;
}

.quote-compact__edit .view-ass-btn::before {
  content: "edit";
  font-family: "Material Icons";
  font-size: 17px;
  line-height: 1;
}

.quote-compact .v-text-field > .v-input__control > .v-input__slot,
.quote-compact .v-select > .v-input__control > .v-input__slot {
  min-height: 38px;
}

.quote-compact .v-input input,
.quote-compact .v-select__selection,
.quote-compact .v-label {
  font-size: 12px;
}

.quote-compact .v-input,
.quote-compact .v-input__control,
.quote-compact .v-input__slot {
  cursor: default;
  transition: none !important;
}

.quote-compact .v-input:not(.v-input--is-disabled) input {
  cursor: text !important;
}

.quote-compact .v-input--is-disabled,
.quote-compact .v-input--is-disabled * {
  cursor: default !important;
}

.quote-compact .v-text-field__details {
  display: none;
}

.quote-compact__grid {
  gap: 8px;
}

.quote-compact__edit {
  min-height: 38px;
  min-width: 38px;
  padding-top: 0 !important;
}

.quote-compact__edit .log {
  align-items: center;
  display: inline-flex !important;
  justify-content: center;
  min-height: 30px;
  min-width: 30px;
}

.quote-compact__driver-price-popup,
.quote-compact__customer-price-popup {
  display: inline-flex;
  height: 0;
  min-height: 0;
  min-width: 0;
  overflow: visible;
  width: 0;
}

.quote-compact__driver-price-popup .view-ass-btn--driver-price,
.quote-compact__customer-price-popup .view-ass-btn {
  display: none !important;
}

.quote-compact__driver-edit-btn {
  align-items: center !important;
  background: #fff7ed !important;
  border: 1px solid #fed7aa !important;
  border-radius: 6px !important;
  box-shadow: none !important;
  color: #a85510 !important;
  cursor: pointer;
  display: inline-flex !important;
  height: 38px !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 38px !important;
  min-width: 38px !important;
  opacity: 1 !important;
  padding: 0 !important;
  position: relative;
  visibility: visible !important;
  width: 38px !important;
  z-index: 2;
}

.quote-compact__driver-edit-btn .v-icon {
  color: currentColor !important;
  font-size: 17px !important;
}

.quote-compact__driver-edit-btn:hover:not([disabled]) {
  background: #ffedd5 !important;
  border-color: #fdba74 !important;
  color: #8a420b !important;
}

.quote-compact__driver-edit-btn[disabled] {
  background: #f2f4f7 !important;
  border-color: #e4e7ec !important;
  color: #98a2b3 !important;
  cursor: default;
}

.quote-compact__edit .view-ass-btn:not(.view-ass-btn--driver-price) {
  border-radius: 6px !important;
  color: transparent !important;
  display: inline-flex !important;
  height: 30px;
  line-height: 1 !important;
  min-width: 30px;
  opacity: 1 !important;
  overflow: hidden;
  position: relative;
  text-indent: -999px;
  visibility: visible !important;
  width: 30px;
}

.quote-compact__edit .view-ass-btn:not(.view-ass-btn--driver-price)::before {
  color: #a85510 !important;
  content: "edit" !important;
  display: inline-block !important;
  font-family: "Material Icons";
  font-size: 17px;
  left: 50%;
  line-height: 1;
  position: absolute;
  text-indent: 0;
  top: 50%;
  transform: translate(-50%, -50%);
  visibility: visible !important;
  z-index: 1;
}

.theme--dark .quote-compact__edit .view-ass-btn:not(.view-ass-btn--driver-price),
.application--dark .quote-compact__edit .view-ass-btn:not(.view-ass-btn--driver-price),
.theme--dark .quote-compact__driver-edit-btn,
.application--dark .quote-compact__driver-edit-btn {
  background: rgba(245, 130, 32, 0.16) !important;
  border-color: rgba(245, 130, 32, 0.34) !important;
}

.theme--dark .quote-compact__edit .view-ass-btn:not(.view-ass-btn--driver-price)::before,
.application--dark .quote-compact__edit .view-ass-btn:not(.view-ass-btn--driver-price)::before {
  color: #fdba74 !important;
}

@media (max-width: 980px) {
  .quote-compact__grid {
    grid-template-columns: 1fr;
  }
}

/* Pricing bar: a slim horizontal strip across the top of the lane:
   "PRICING" label, then one segment per price (label + amount + edit). */
.quote-tiles {
  align-items: stretch;
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.5rem;
  display: flex;
  flex-wrap: wrap;
  /* Only as wide as its content, pinned to the right end of the lane. */
  margin-left: auto;
  max-width: 100%;
  overflow: hidden;
  width: fit-content;
}

.quote-tiles__header {
  align-items: center;
  background: var(--oms-surface-soft, #faf9f6);
  border-right: 0.0625rem solid var(--oms-border, #ebe9e2);
  color: var(--oms-ink, #3a382f);
  display: flex;
  font-size: 0.75rem;
  font-weight: 800;
  gap: 0.375rem;
  letter-spacing: 0.04em;
  padding: 0.625rem 1rem;
  text-transform: uppercase;
}

.quote-tiles__header .v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 1rem !important;
}

.quote-tile {
  align-items: center;
  display: flex;
  flex: 0 1 auto;
  gap: 1rem;
  min-width: 11rem;
  padding: 0.5rem 0.75rem 0.5rem 1rem;
  position: relative;
}

.quote-tile + .quote-tile {
  border-left: 0.0625rem solid var(--oms-border, #ebe9e2);
}

/* Customer price is the headline figure: a thin orange accent underneath. */
.quote-tile--customer::after {
  background: var(--oms-primary, #ea7a1c);
  border-radius: 0.125rem 0.125rem 0 0;
  bottom: 0;
  content: "";
  height: 0.1875rem;
  left: 1rem;
  position: absolute;
  right: 0.75rem;
}

/* Editor components only host their popup; their root takes no space. */
.quote-tile__editor {
  display: none !important;
}

.quote-tile__text {
  display: flex;
  flex-direction: column;
  gap: 0.0625rem;
  min-width: 0;
}

.quote-tile__label {
  color: var(--oms-muted, #74716a);
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.quote-tile__value {
  align-items: baseline;
  color: var(--oms-ink-strong, #1a1916);
  display: flex;
  font-size: 1.0625rem;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  gap: 0.3125rem;
  line-height: 1.25;
  white-space: nowrap;
}

.quote-tile__value small {
  color: var(--oms-muted, #74716a);
  font-size: 0.6875rem;
  font-weight: 700;
}

.quote-tile__edit-btn {
  align-items: center;
  background: transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.5rem;
  color: var(--oms-muted, #74716a);
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2rem;
  justify-content: center;
  margin-left: auto;
  padding: 0;
  transition: background-color 0.16s ease, color 0.16s ease,
    border-color 0.16s ease;
  width: 2rem;
}

.quote-tile__edit-btn .v-icon {
  color: currentColor !important;
  font-size: 1rem !important;
}

.quote-tile__edit-btn:hover:not([disabled]),
.quote-tile__edit-btn:focus-visible {
  background: var(--oms-primary-soft, #fdf0e4);
  border-color: var(--oms-peach-border, #fed7aa);
  color: var(--oms-primary-dark, #d96a10);
  outline: none;
}

.quote-tile__edit-btn[disabled] {
  color: var(--oms-disabled-ink, #b4b0a6);
  cursor: default;
}

@media (max-width: 40rem) {
  .quote-tiles {
    width: 100%;
  }

  .quote-tiles__header {
    border-bottom: 0.0625rem solid var(--oms-border, #ebe9e2);
    border-right: 0;
    flex: 1 0 100%;
  }

  .quote-tile {
    flex: 1 1 100%;
  }

  .quote-tile + .quote-tile {
    border-left: 0;
    border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  }
}
</style>
